/* Shopify cart: product buttons add to the real Shopify cart. */
(function () {
  function paint(n) {
    document.querySelectorAll('[data-shop-count]').forEach(function (el) {
      el.textContent = n; el.style.display = n ? 'flex' : 'none';
    });
  }
  function refresh() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { paint(c.item_count); }); }
  var tnode, ttimer;
  function toast(msg) {
    if (!tnode) { tnode = document.createElement('div'); tnode.className = 'toast'; tnode.setAttribute('role', 'status'); document.body.appendChild(tnode); }
    tnode.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
    tnode.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { tnode.classList.add('show'); });
    clearTimeout(ttimer); ttimer = setTimeout(function () { tnode.classList.remove('show'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip][data-price]');
    if (chip) {   // variant chip: update the shown price
      var p = +chip.dataset.price, run = document.querySelector('[data-running]');
      document.querySelectorAll('[data-vprice]').forEach(function (el) { el.textContent = '$' + p.toLocaleString('en-US'); });
      if (run) { run.dataset.unit = p; var q = document.getElementById('qty'); if (q) q.dispatchEvent(new Event('input')); }
    }
    var b = e.target.closest('[data-sadd]');
    if (!b) return;
    e.preventDefault();
    var id = b.dataset.variant, on = document.querySelector('[data-chip][aria-pressed="true"]');
    if (b.hasAttribute('data-qty') && on && on.dataset.variant) id = on.dataset.variant;
    var box = document.getElementById('qty');
    var qty = (b.hasAttribute('data-qty') && box) ? Math.max(1, parseInt(box.value, 10) || 1) : 1;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); return refresh(); })
      .then(function () { toast((b.dataset.name || 'Item') + ' × ' + qty + ' added'); })
      .catch(function () { toast('Could not add to cart. Please try again.'); });
  });
  refresh();
})();
